import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import ButtonUI from '../../widgets/action/ButtonUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import GoogleLoginSF from '../../components/login/GoogleLoginSF'
import FBLoginSF from '../../components/login/FBLoginSF'
import SignUpWithEmailSF from '../../components/public/SignUpWithEmailSF'

const SignUpWithEmailPageUI = ({context, messageList, captchaKey, socialLoginUrl,
    signUpWithPassword, onSignUpWithPasswordClick, showFBLogin}) =>
  <PublicPageSF context={context} className='pg_signup' backLink='/' centered={!captchaKey}
    messageList={messageList} headerMessageKey='c_sign_up'>
    {
      !captchaKey &&
      <SpinnerComponentUI />
    }
    {
      captchaKey &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/' messageList={messageList} titleMessageKey='c_sign_up' />
        {
          !signUpWithPassword &&
          <div className='signup g_m_top_100 g_text_center'>
            <ButtonUI messageList={messageList} labelKey='c_sign_up_w_email_pwd'
              onClick={onSignUpWithPasswordClick}
              transparent={false}
            />
          </div>
        }

        {
          signUpWithPassword &&
          <SignUpWithEmailSF context={context} captchaKey={captchaKey} />
        }

        {/* */}
        <div className='g_m_top_100 g_text_center'>
          <MessageUI messageList={messageList} messageKey='c_or' />
        </div>

        <div className='google'>
          <GoogleLoginSF context={context} messageList={messageList} socialLoginUrl={socialLoginUrl} />
        </div>
        {/* */}

        {
          showFBLogin &&
          <React.Fragment>
            <div className='g_m_top_100 g_text_center'>
              <MessageUI messageList={messageList} messageKey='c_or' />
            </div>

            <div className='facebook'>
              <FBLoginSF context={context} messageList={messageList} socialLoginUrl={socialLoginUrl} />
            </div>
          </React.Fragment>
        }

        <div className='g_text_center g_m_top_100'>
          <MessageUI messageList={messageList} messageKey='c_signup_agreeto_terms' />
        </div>
      </React.Fragment>
    }
  </PublicPageSF>

export default SignUpWithEmailPageUI
